<template>
    <div id="navBar" ref="navBar">
        <nav>
            <section class="fl">
                <router-link :to="{name:'home'}">
                    <img src="../assets/img/logo.png" alt="艺成园工程" title="艺成园工程">
                </router-link>
            </section>
            <section class="fr">
                <ul>
                    <li v-for="item in navTitle" :key="item.id" @click="jumpTab">
                        <router-link :to="{name:item.routerName}">{{ item.title }}</router-link>
                    </li>
                </ul>
            </section>
        </nav>
    </div>
</template>
<script>
const navTitle = [
    {id:1,title:'首页',routerName:'home'},
    {id:2,title:'关于我们',routerName:'aboutUs'},
    {id:3,title:'新闻媒体',routerName:'newsMedia'},
    {id:4,title:'业务领域',routerName:'businessArea'},
    {id:5,title:'工程业绩',routerName:'engineeringPerformance'},
    {id:6,title:'加入我们',routerName:'joinUs'},
]
export default {
    name:'navBar',
    data() {
        return {
            navTitle:navTitle,
        }
    },
    methods:{
        onScroll(){
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if(scrollTop == 0){
                this.$refs.navBar.style.position = 'absolute';
                this.$refs.navBar.style.transform = 'translateY(0px)';
            }else{
                this.$refs.navBar.style.position = 'fixed';
                this.$refs.navBar.style.top = '0px';
                this.$refs.navBar.style.transform = 'translateY(-22px)';
            }
        },
        jumpTab() {
            (document.documentElement.scrollTop = 0) || (document.body.scrollTop = 0);
        }
    },
    created(){
        window.addEventListener('scroll',this.onScroll);
    },
    beforeDestroy(){
        window.removeEventListener('scroll',this.onScroll)
    }
}
</script>
<style scoped>
#navBar{
    width: 100%;
    background:linear-gradient(rgba(0,0,0,1), rgba(255,255,255,0));
    z-index: 888;
    transition: 0.5s 0.5s ease-in-out;
    height: 130px;
    padding-top: 22px;
    position: absolute;
}
nav{
    width: 1400px;
    height: 108px;
    line-height: 108px;
    margin: 0px auto;
}
section>a>img{
    width: 174px;
    height: 60px;
}
section>ul li{
    float: left;
    margin-left: 58px;
}
section>ul li a{
    color: #ffffff;
    font-size: 16px;
    padding-bottom: 10px;
    position: relative;
    cursor: pointer;
}
section>ul li a::after{
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0px;
    background-color: #ffffff;
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -ms-transform: scale(0);
    transform-origin: left;
    -webkit-transform-origin: left;
    -moz-origin: left;
    -ms-origin: left;
}
section>ul li a.router-link-active::after{
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #ffffff;
    transform: scale(1);
    -webkit-transform:scale(1); 
}
section>ul li a:hover::after{
    height: 3px;
    transition: 0.5s;
    -webkit-transition: 0.5s;
    transform: scale(1);
    -webkit-transform:scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue